/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceIncidentConfigurationMappingForPolicyViolation extends models.FreshserviceIncidentConfigurationMappingBase {
    getFixupPrototypeFunction() { return FreshserviceIncidentConfigurationMappingForPolicyViolation.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceIncidentConfigurationMappingForPolicyViolation>): FreshserviceIncidentConfigurationMappingForPolicyViolation {
        let obj = Object.assign(new FreshserviceIncidentConfigurationMappingForPolicyViolation(), model);
        FreshserviceIncidentConfigurationMappingForPolicyViolation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceIncidentConfigurationMappingForPolicyViolation>): FreshserviceIncidentConfigurationMappingForPolicyViolation {
        if (!model) return null;
        return FreshserviceIncidentConfigurationMappingForPolicyViolation.newInstance(<FreshserviceIncidentConfigurationMappingForPolicyViolation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceIncidentConfigurationMappingForPolicyViolation) {
        if (!obj) return;

        models.FreshserviceIncidentConfigurationMappingForPolicyViolation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceIncidentConfigurationMappingForPolicyViolation): boolean {
        if (models.FreshserviceIncidentConfigurationMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, FreshserviceIncidentConfigurationMappingForPolicyViolation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Allowed attributes for Policy Description
     */
    value: models.DescriptionAttributeForItsmPolicy;

    value_direct: string;

}
